import {getSolutionFormDefaultValues} from '@/modules/drug-catalog/solutions/functions'
import {Box} from '@chakra-ui/react'
import {FormSection} from '@cypro/ui/components/form/form-section'
import {FormGrid} from '@cypro/ui/components/ui/form-grid'
import {withForm} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'

export const SolutionAlternativeCodesTab = withForm({
  defaultValues: getSolutionFormDefaultValues(undefined),
  render: function Render({form}) {
    const {t} = useTranslate('common')
    const {t: tSolutions} = useTranslate('solutions')

    return (
      <Box spaceY="8">
        <FormSection
          label={tSolutions('nomenclature_codes')}
          description={tSolutions('nomenclature_codes_description')}
        >
          <FormGrid>
            <form.AppField name="prescribingName">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('prescribing_name')}
                  placeholder={tSolutions('prescribing_name_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="nationalId">
              {field => (
                <field.TextField
                  size="sm"
                  label={t('national_id')}
                  placeholder={tSolutions('national_id_placeholder')}
                />
              )}
            </form.AppField>

            <form.AppField name="atcCode">
              {field => (
                <field.TextField size="sm" label={t('atc_code')} placeholder={tSolutions('atc_code_placeholder')} />
              )}
            </form.AppField>

            <form.AppField name="code">
              {field => (
                <field.TextField size="sm" label={t('internal_id')} placeholder={tSolutions('code_placeholder')} />
              )}
            </form.AppField>
          </FormGrid>
        </FormSection>

        <FormSection label={tSolutions('additional_notes')} description={tSolutions('additional_notes_description')}>
          <FormGrid>
            <Box gridColumn="span 2">
              <form.AppField name="description">
                {field => (
                  <field.Textarea
                    size="sm"
                    label={t('description')}
                    placeholder={tSolutions('description_placeholder')}
                    rows={4}
                  />
                )}
              </form.AppField>
            </Box>
          </FormGrid>
        </FormSection>
      </Box>
    )
  },
})
